var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BaseApp } from "../base-app";
import { PLATFORM } from "aurelia-pal";
import { autoinject } from "aurelia-dependency-injection";
import { Router } from "aurelia-router";
import * as Enumerable from "linq";
import { computedFrom } from "aurelia-binding";
import { SignalClientService } from "../../../services/basics/signal-client.service";
import { RouterConstants } from "../../../configuration/router.constants";
import { EventAggregator } from "aurelia-event-aggregator";
import { DialogClientService } from "../../../services/basics/dialog-client.service";
import { BindingSignaler } from "aurelia-templating-resources";
import { TokenClient } from "../../../services/authentication/token-client.service";
import { EntityTypeConfigurationHelper, } from "../../../models/basics/basics.models";
import { StringUtilities } from "../../../utilities/strings";
import { CacheClient } from "../../../services/basics/client-caching.service";
import { NavigationClientService } from "../../../services/modules/navigation-client.service";
import { LoginDialog } from "./dialogs/login-dialog";
import { I18N } from "aurelia-i18n";
import { BrandClientService, LotteryKeyHelper, BundleKeyHelper, TemplateType } from "../../../services/modules/brand-client.service";
import { Guid } from "../../../utilities/guid";
import { LookupClientService } from "../../../services/lookups/lookup-client.service";
import { GamePlayerTicketClientService } from "../../../services/modules/client/client-game-player-ticket-client.service";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import { ClientLotteryClientService } from '../../../services/modules/client/client-lottery-client-service';
import { IFramePostMessages, SystemEvents } from "../../../models/modules/lotteryplatform-client.models";
import { ExternalLogin } from "../../../services/authentication/external-login";
import { RoutingHelper } from "../../../helpers/routing.helper";
import { ConfigClientService } from "../../../services/modules/client-config.service";
var Client = /** @class */ (function (_super) {
    __extends(Client, _super);
    function Client(router, entityTypeConfigurationHelper, brandClientService, routingHelper, signalClientService, eventAggregator, clientLotteryClientService, lookupsService, tokenClient, // do not remove this its being used in the html
    bindingSignaler, cacheClient, i18n, dialogClient, navigationClient, login, gamePlayerTicketService, notificationClientService, lotteryClientService, externalLogin, configClientService) {
        var _this = _super.call(this, router, tokenClient, dialogClient, eventAggregator, signalClientService, cacheClient, navigationClient, lookupsService) || this;
        _this.entityTypeConfigurationHelper = entityTypeConfigurationHelper;
        _this.brandClientService = brandClientService;
        _this.routingHelper = routingHelper;
        _this.clientLotteryClientService = clientLotteryClientService;
        _this.bindingSignaler = bindingSignaler;
        _this.i18n = i18n;
        _this.login = login;
        _this.gamePlayerTicketService = gamePlayerTicketService;
        _this.notificationClientService = notificationClientService;
        _this.lotteryClientService = lotteryClientService;
        _this.externalLogin = externalLogin;
        _this.configClientService = configClientService;
        _this.entityTypes = _this.entityTypeConfigurationHelper
            .getConfigurationWithoutPermissions(["Lotteries", "Brands"]);
        _this.menu = [];
        eventAggregator.subscribe(Client_1.UpdateCartCount, _this.setCartCount.bind(_this));
        return _this;
    }
    Client_1 = Client;
    Client.prototype.activate = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.activate.call(this)];
                    case 1:
                        _a.sent();
                        if (!!window["ssr"]) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.login.processMessage(this.router)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Client.prototype, "searchOverlayShowing", {
        get: function () {
            return this._searchOverlayShowing;
        },
        set: function (x) {
            this._searchOverlayShowing = x;
            if (!x) {
                this.filter = "";
            }
        },
        enumerable: false,
        configurable: true
    });
    Client.prototype.fixIosUxIssues = function () {
        var _this = this;
        var prevTouch = null;
        document.addEventListener("touchstart", function (e) {
            prevTouch = e.touches[0];
        }, false);
        var lastTime = null;
        var wasScrolling = false;
        var self = this;
        document.addEventListener("touchend", function (e) {
            if (lastTime &&
                !e.target.classList.contains("no-intercept-touch-end") &&
                Math.abs(new Date().getTime() - lastTime) < 400
                && !_this.isNodePartOf(e.target, "BUTTON")) {
                e.preventDefault();
            }
            var target = e.target;
            var scroller = self.getScrollParentVertical(target);
            if (scroller) {
                if (wasScrolling &&
                    (scroller.scrollTop == 0 || scroller.scrollTop == (scroller.scrollHeight - scroller.offsetHeight))) {
                    e.preventDefault();
                    wasScrolling = false;
                }
                else if (!wasScrolling &&
                    (scroller.scrollTop < 0 ||
                        scroller.scrollTop > (scroller.scrollHeight - scroller.offsetHeight))) {
                    wasScrolling = true;
                }
            }
            lastTime = new Date().getTime();
            //e.target.click();
            prevTouch = null;
        }, false);
        document.addEventListener("touchmove", function (e) {
            if (e.touches.length > 1) {
                e.preventDefault();
            }
            if (prevTouch === null) {
                e.preventDefault();
            }
            else {
                var currentTouch = e.touches[0];
                var diff = (prevTouch ? prevTouch.clientY : 0) - currentTouch.clientY;
                var target = e.target;
                var scroller = self.getScrollParentBoth(target);
                if (scroller) {
                    var bool1 = scroller === document.body;
                    var bool2 = document.documentElement === scroller;
                    var bool3 = scroller.scrollHeight > scroller.offsetHeight
                        && scroller.scrollTop <= 0
                        && diff < 0;
                    var bool4 = scroller.scrollHeight > scroller.offsetHeight
                        && scroller.scrollTop >= (scroller.scrollHeight - scroller.offsetHeight)
                        && diff > 0;
                    if (bool1 || bool2 || bool3 || bool4) {
                        //alert("bool1: " + bool1 + " bool2: " + bool2 +" bool3: " + bool3 + " bool4: " + bool4);
                        e.preventDefault();
                    }
                }
                else {
                    e.preventDefault();
                }
            }
        });
        window.addEventListener("scroll", function (ev) {
            if (document.activeElement && document.activeElement.tagName !== "INPUT" && document.activeElement.tagName !== "TEXTAREA") {
                window.scrollTo(window.scrollX, 0);
            }
        });
    };
    Client.prototype.getScrollParentVertical = function (node) {
        if (node == null) {
            return null;
        }
        if (node.scrollHeight > node.clientHeight) {
            return node;
        }
        else {
            return this.getScrollParentVertical(node.parentNode);
        }
    };
    Client.prototype.getScrollParentBoth = function (node) {
        if (node == null) {
            return null;
        }
        if (node.scrollHeight > node.clientHeight || node.scrollWidth > node.clientWidth) {
            return node;
        }
        else {
            return this.getScrollParentBoth(node.parentNode);
        }
    };
    Client.prototype.isNodePartOf = function (node, tagName) {
        while (node != null && node.tagName != tagName) {
            if (node.classList.contains("no-intercept-touch-end")) {
                return true;
            }
            node = node.parentElement;
        }
        return node != null;
    };
    Object.defineProperty(Client.prototype, "style", {
        get: function () {
            return this.tokenClient && this.tokenClient.user && this.tokenClient.user.brandId ? this.tokenClient.user.brandId.toString() : "default";
        },
        enumerable: false,
        configurable: true
    });
    Client.prototype.getRoutes = function (tokenClient) {
        var _this = this;
        this.templateName = tokenClient.user.templateName.toLowerCase();
        try {
            require("../../../styles/client/templates/" + this.templateName + "/lobby/lobby");
        }
        catch (_a) { }
        try {
            require("../../../styles/client/templates/" + this.templateName + "/lottery/lottery");
        }
        catch (_b) { }
        try {
            require("../../../styles/client/templates/" + this.templateName + "/lotteries/lotteries");
        }
        catch (_c) { }
        try {
            require("../../../styles/client/templates/" + this.templateName + "/results/results");
        }
        catch (_d) { }
        try {
            require("../../../styles/client/templates/" + this.templateName + "/cart/cart");
        }
        catch (_e) { }
        try {
            require("../../../styles/client/templates/" + this.templateName + "/purchases/purchases");
        }
        catch (_f) { }
        try {
            require("../../../styles/client/templates/" + this.templateName + "/agent/agent-winning-claims");
        }
        catch (_g) { }
        try {
            require("../../../styles/client/templates/" + this.templateName + "/bundle/bundle");
        }
        catch (_h) { }
        try {
            require("../../../styles/client/templates/" + this.templateName + "/bundles/bundles");
        }
        catch (_j) { }
        try {
            require("../../../styles/client/templates/" + this.templateName + "/syndicate/syndicate");
        }
        catch (_k) { }
        try {
            require("../../../styles/client/templates/" + this.templateName + "/about/about");
        }
        catch (_l) { }
        try {
            require("../../../styles/client/templates/" + this.templateName + "/how-to-play/how-to-play");
        }
        catch (_m) { }
        try {
            require("../../../styles/client/templates/" + this.templateName + "/how-to-win/how-to-win");
        }
        catch (_o) { }
        try {
            require("../../../styles/client/templates/" + this.templateName + "/prize-matrix/prize-matrix");
        }
        catch (_p) { }
        try {
            var navigation = require("../../../styles/client/templates/" + this.templateName + "/common/navigation-menu").NavigationMenu;
            this.navigationMenu = new navigation(this.router, this.gamePlayerTicketService, this.eventAggregator, this.tokenClient, this.notificationClientService, this.i18n, this.lotteryClientService, this.dialogClient);
        }
        catch (_q) { }
        var menu = [
            {
                title: this.i18n.tr("navigation-nav-home"),
                name: RouterConstants.RouteNames.Lobby,
                route: [
                    "client", "client/lobby",
                    "pariplay/game", "pariplay/game/lobby",
                    "preview", "preview/lobby", "preview/instant-game/:instantGameId",
                    "lobby"
                ],
                settings: { icon: "home", isMainNavigation: true, isHome: true },
                nav: true,
                moduleId: PLATFORM.moduleName("../../../styles/client/templates/" + this.templateName + "/lobby/lobby")
            },
            {
                title: this.i18n.tr("lottery"),
                name: RouterConstants.RouteNames.Lottery,
                route: [
                    "client/lottery/:brandLotteryId/:lotteryId/:key",
                    "lottery/:brandLotteryId/:lotteryId/:key",
                    "pariplay/game/lottery/:lotteryId/:key",
                    "preview/lottery/:lotteryId/:key",
                ],
                settings: { icon: "", isMainNavigation: false },
                nav: false,
                moduleId: PLATFORM.moduleName("../../../styles/client/templates/" + this.templateName + "/lottery/lottery")
            },
            {
                title: this.i18n.tr("navigation-nav-lotteries"),
                name: RouterConstants.RouteNames.Lotteries,
                route: [
                    "client/lotteries",
                    "lotteries",
                    "pariplay/game/lottery/:lotteryId/:key",
                    "preview/lotteries",
                ],
                settings: { icon: "", isMainNavigation: true },
                nav: true,
                moduleId: PLATFORM.moduleName("../../../styles/client/templates/" + this.templateName + "/lotteries/lotteries")
            },
            {
                title: this.i18n.tr("bundle"),
                name: RouterConstants.RouteNames.Bundle,
                route: [
                    "client/bundle/:bundleId/:key",
                    "bundle/:bundleId/:key",
                    "pariplay/game/bundle/:bundleId/:key",
                    "preview/bundle/:bundleId/:key",
                ],
                settings: { icon: "", isMainNavigation: false },
                nav: false,
                moduleId: PLATFORM.moduleName("../../../styles/client/templates/" + this.templateName + "/bundle/bundle")
            },
            {
                title: this.i18n.tr("navigation-nav-bundles"),
                name: RouterConstants.RouteNames.Bundles,
                route: [
                    "client/bundles",
                    "bundles",
                    "pariplay/game/bundle/:bundleId/:key",
                    "preview/bundle",
                ],
                settings: { icon: "", isMainNavigation: true },
                nav: true,
                moduleId: PLATFORM.moduleName("../../../styles/client/templates/" + this.templateName + "/bundles/bundles")
            },
            {
                title: this.i18n.tr("navigation-nav-latest-results"),
                name: RouterConstants.RouteNames.Results,
                route: [
                    "pariplay/game/results",
                    "preview/results",
                    "client/results",
                    "results"
                ],
                settings: { icon: "assignment", isMainNavigation: true, isResults: true },
                nav: true,
                moduleId: PLATFORM.moduleName("../../../styles/client/templates/" + this.templateName + "/results/results")
            },
            {
                title: this.i18n.tr("navigation-nav-my-purchases"),
                name: RouterConstants.RouteNames.Purchases,
                route: [
                    "pariplay/game/purchases",
                    "preview/purchases",
                    "client/purchases",
                    "purchases"
                ],
                settings: { icon: "local_play", isMainNavigation: true, isPurchase: true },
                nav: true,
                auth: true,
                moduleId: PLATFORM.moduleName("../../../styles/client/templates/" + this.templateName + "/purchases/purchases")
            },
            {
                title: this.i18n.tr("navigation-nav-cart"),
                name: RouterConstants.RouteNames.Cart,
                route: [
                    "pariplay/game/cart",
                    "preview/cart",
                    "client/cart",
                    "cart"
                ],
                settings: { icon: "shopping_cart", isMainNavigation: true, isCart: true },
                nav: true,
                moduleId: PLATFORM.moduleName("../../../styles/client/templates/" + this.templateName + "/cart/cart")
            }
        ];
        try {
            menu.push({
                title: this.i18n.tr("syndicate"),
                name: RouterConstants.RouteNames.Syndicate,
                route: [
                    "client/syndicate/:brandLotteryId/:syndicateId/:key",
                    "syndicate/:brandLotteryId/:syndicateId/:key",
                    "pariplay/game/syndicate/:brandLotteryId/:syndicateId/:key",
                    "preview/syndicate/:brandLotteryId/:syndicateId/:key"
                ],
                settings: { icon: "", isMainNavigation: false },
                nav: false,
                moduleId: PLATFORM.moduleName("../../../styles/client/templates/" + this.templateName + "/syndicate/syndicate")
            });
        }
        catch (_r) {
            console.log("syndicate module not found!");
        }
        if (this.tokenClient.user && this.tokenClient.user.isAgent) {
            menu.push({
                title: this.i18n.tr("navigation-nav-agent-winning-claims"),
                name: RouterConstants.RouteNames.AgentWinningClaims,
                route: [
                    "preview/agent-winning-claims",
                    "client/agent-winning-claims",
                    "agent-winning-claims"
                ],
                settings: { icon: "star", isMainNavigation: true },
                nav: true,
                auth: true,
                moduleId: PLATFORM.moduleName("../../../styles/client/templates/" + this.templateName + "/agent/agent-winning-claims")
            });
        }
        this.configClientService.getClientConfig(TemplateType.Config).then(function (x) {
            var showLotteriesPage = x[TemplateType.Config]["template"]["show-lotteries-page"];
            var showBundlesPage = x[TemplateType.Config]["template"]["show-bundles-page"];
            if (!showLotteriesPage) {
                var indexOf = _this.menu.indexOf(_this.menu.filter(function (x) { return x.name == RouterConstants.RouteNames.Lotteries; })[0]);
                _this.menu.splice(indexOf, 1);
            }
            if (!showBundlesPage) {
                var indexOf = _this.menu.indexOf(_this.menu.filter(function (x) { return x.name == RouterConstants.RouteNames.Bundles; })[0]);
                _this.menu.splice(indexOf, 1);
            }
            if (x[TemplateType.Config]["external-terms-and-conditions"]) {
                _this.tokenClient.externalTermsAndConditionsConfig = {
                    enabled: x[TemplateType.Config]["external-terms-and-conditions"]["show-external-terms-and-conditions"],
                    name: x[TemplateType.Config]["external-terms-and-conditions"][_this.tokenClient.lang]["external-terms-and-conditions-name"],
                    url: x[TemplateType.Config]["external-terms-and-conditions"][_this.tokenClient.lang]["external-terms-and-conditions-url"]
                };
            }
            var termsAndCondionsUrl = "";
            var user = _this.tokenClient.user;
            if (user.enableMultilingualTermsAndConditions)
                termsAndCondionsUrl = "/Home/TermsAndConditions?brandid=" + user.brandId + "&lang=" + user.languageCode;
            else
                termsAndCondionsUrl = "/Home/TermsAndConditions?brandid=" + user.brandId;
            _this.tokenClient.termsAndConditionConfig = {
                enabled: x[TemplateType.Config]["template"]["show-terms-and-conditions"],
                url: termsAndCondionsUrl
            };
        });
        this.menu = Enumerable.from(menu).where(function (x) { return x.settings.isMainNavigation && (!x.auth || x.auth == tokenClient.isAuthenticated); }).toArray();
        if (this.navigationMenu)
            this.navigationMenu.menu = this.menu;
        return menu;
    };
    Client.prototype.setCartCount = function () {
        var _this = this;
        this.gamePlayerTicketService.getCartCount().then(function (x) {
            _this.cartCount = x;
            _this.navigationMenu.setCartCount(x);
            window.parent.postMessage({
                event: IFramePostMessages.onCartCountChange,
                detail: {
                    count: x
                }
            }, "*");
        }).catch(function (x) {
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
    };
    Client.prototype.searchItemSelected = function (e) {
        if (e.detail && e.detail.selectedEntityType && e.detail.selectedEntity) {
            var route = Enumerable.from(this.getRoutes(this.tokenClient))
                .firstOrDefault(function (x) { return x.entityTypeRoute == e.detail.selectedEntityType; });
            var item = e.detail.selectedEntity;
            this.navigationClientService.navigateAndCache(route.name, { id: item[StringUtilities.camelize(item.idPropertyName)] });
        }
    };
    Client.prototype.getScrollParent = function (element, includeHidden) {
        var style = getComputedStyle(element);
        var excludeStaticParent = style.position === "absolute";
        var overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;
        if (style.position === "fixed")
            return document.body;
        for (var parent = element; (parent = parent.parentElement);) {
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === "static") {
                continue;
            }
            if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX))
                return parent;
        }
        return document.body;
    };
    Client.prototype.attached = function () {
        var _this = this;
        if (this.tokenClient.currentlyLockedByUser) {
            window.parent.postMessage({
                event: IFramePostMessages.currentlyLockedPreview,
                detail: {
                    locked: true,
                    user: this.tokenClient.currentlyLockedByUser
                }
            }, "*");
        }
        else {
            //send an unlocked preview details in order to enable buttons when template is changed
            window.parent.postMessage({
                event: IFramePostMessages.currentlyLockedPreview,
                detail: {
                    locked: false,
                    user: ""
                }
            }, "*");
        }
        //this.fixIosUxIssues();
        _super.prototype.attached.call(this);
        this.setCartCount();
        this.navigationMenu.setPurchaseCount();
        if (window["ssr"]) { // if server side rendering stop here
            setTimeout(function () {
                window.dispatchEvent(new CustomEvent('lottery-platform-loaded', {
                    detail: ""
                }));
            });
        }
        else {
            this.selectedRoute = Enumerable.from(this.routes).first(function (x) { return x.name == _this.router.currentInstruction.config.name; });
            if (this.navigationMenu)
                this.navigationMenu.selectedRoute = this.selectedRoute;
            this.eventAggregator.subscribe("router:navigation:complete", function (response) {
                _this.searchOverlayShowing = false;
                if (_this.dialogClient.isModalVisible) {
                    _this.dialogClient.hide();
                }
                // check if navigation was cancelled
                _this.selectedRoute = Enumerable.from(_this.routes).first(function (x) { return x.name === _this.router.currentInstruction.config.name; });
                if (_this.navigationMenu)
                    _this.navigationMenu.selectedRoute = _this.selectedRoute;
                _this.navigationClientService.setTitle(_this.selectedRoute.title);
                _this.bindingSignaler.signal("refresh-is-active");
                $('.router-view').scrollTop(0);
            });
            this.eventAggregator.subscribe("router:navigation:processing", function (data) {
                if (!_this.scrollElement) {
                    var element = document.getElementsByClassName('router-view').item(0);
                    _this.scrollElement = element ? _this.getScrollParent(element, false) : null;
                }
                if (_this.scrollElement) {
                    _this.scrollElement.scrollTop = 0;
                }
            });
            var global = window;
            var server = global.server;
            var inspetletApiSettings = server.inspetletApiSettings;
            var websiteId_1 = inspetletApiSettings ? inspetletApiSettings.WebsiteId : null;
            //Begin Inspectlet JS Code
            if (document.createElement && inspetletApiSettings && websiteId_1) {
                var insp = "__insp";
                var inspld = "__inspld";
                window[insp] = window[insp] || [];
                //resetSession will create a new session instead of continue using the same session in the cookie
                window[insp].push(["resetSession"]);
                window[insp].push(['wid', 1685511673]);
                window[insp].push(['tagSession', { recordingSessionId: Client_1.RECORDING_SESSION_ID }]);
                var ldinsp = function () {
                    if (typeof window[inspld] != "undefined")
                        return;
                    window[inspld] = 1;
                    var insp = document.createElement('script');
                    insp.type = 'text/javascript';
                    insp.async = true;
                    insp.id = "inspsync";
                    insp.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js?wid=' + websiteId_1 + '&r=' + Math.floor(new Date().getTime() / 3600000);
                    var x = document.getElementsByTagName('script')[0];
                    x.parentNode.insertBefore(insp, x);
                };
                setTimeout(ldinsp, 0);
            }
            var gameId_1 = this.tokenClient.gameId;
            if (gameId_1) {
                var instantGamePromise = this.clientLotteryClientService.getLobbyBrandInstantGames({});
                var bundlePromise = this.lotteryClientService.getLobbyBundles({ getIsPromotionBundles: true });
                var lotteriesPromise = this.lotteryClientService.getLobbyBrandLotteries({});
                Promise.all([instantGamePromise, bundlePromise, lotteriesPromise]).then(function (x) {
                    var instantGame = x[0] && x[0].length >= 1 ? x[0].find(function (z) { return z.gameIdentifier.toLowerCase() == gameId_1.toLowerCase(); }) : null;
                    var bundle = x[1] && x[1].length >= 1 ? x[1].find(function (z) { return z.gameIdentifier.toLowerCase() == gameId_1.toLowerCase(); }) : null;
                    var lottery = x[2] && x[2].length >= 1 ? x[2].find(function (z) { return z.gameIdentifier.toLowerCase() == gameId_1.toLowerCase(); }) : null;
                    if (instantGame) {
                        setTimeout(function () {
                            _this.routingHelper.showInstantGameDialog(instantGame);
                        });
                    }
                    if (bundle) {
                        setTimeout(function () {
                            _this.router.navigateToRoute(RouterConstants.RouteNames.Bundle, { key: BundleKeyHelper.getKey(bundle.name), bundleId: bundle.bundleId }, { replace: true });
                        });
                    }
                    if (lottery) {
                        setTimeout(function () {
                            _this.routingHelper.navigateToLottery(lottery);
                        });
                    }
                });
            }
            window.addEventListener(SystemEvents.externalLogin, function (x) {
                _this.externalLogin.PostExternalLogin(x.detail);
            });
            window.addEventListener('message', function (x) {
                if (x && x.data && x.data.event == IFramePostMessages.navigate) {
                    var detail = x.data.detail;
                    if (detail.routeName.toLowerCase() == 'lottery' && detail.params.lotteryId) {
                        _this.clientLotteryClientService.getLobbyBrandLotteries({}).then(function (lotteries) {
                            var lottery = Enumerable.from(lotteries).firstOrDefault(function (x) { return x.lotteryId == detail.params.lotteryId; });
                            _this.router.navigateToRoute(detail.routeName, {
                                brandLotteryId: lottery.brandLotteryId,
                                lotteryId: lottery.lotteryId,
                                key: LotteryKeyHelper.getKey(lottery.lotteryName)
                            }, { replace: true });
                        }, function (x) {
                        });
                    }
                    else {
                        _this.router.navigateToRoute(detail.routeName, detail.params, { replace: true });
                    }
                }
                else if (x && x.data && x.data.event == IFramePostMessages.onScroll) {
                    var detail = x.data.detail;
                    var fullPage = detail.scroll + detail.pageHeight;
                    _this.overlayHeight = detail.overlayHeight;
                    var totalHeight = window.innerHeight;
                    if (fullPage > totalHeight) {
                        fullPage = totalHeight;
                    }
                    _this.windowScroll = detail.scroll;
                    _this.windowHeight = detail.pageHeight;
                    if (_this.navigationMenu) {
                        _this.navigationMenu.setCartTop(fullPage - 60);
                    }
                    //Check if the Cart FAB is showning
                    if (_this.cartCount > 0) {
                        _this.notificationTop = totalHeight - fullPage + 80;
                    }
                    else {
                        _this.notificationTop = totalHeight - fullPage;
                    }
                    _this.dialogBottom = totalHeight - fullPage;
                    window['screenHeight'] = detail && detail.pageHeight ? detail.pageHeight : "";
                }
                else if (x && x.data && x.data.event == IFramePostMessages.onScreenChange) {
                    var detail = x.data.detail;
                    var totalHeight = window.innerHeight;
                    if (detail && detail.pageHeight) {
                        var fullPage = detail.scroll + detail.pageHeight;
                        _this.windowHeight = detail.pageHeight;
                        _this.dialogBottom = totalHeight - fullPage;
                    }
                    window['screenHeight'] = detail && detail.pageHeight ? detail.pageHeight : "";
                    window.screenOrientation = detail && detail.orientation ? detail.orientation : "";
                    window.dispatchEvent(new CustomEvent(IFramePostMessages.onScreenChange, { detail: detail }));
                }
                else if (x && x.data && x.data.event == IFramePostMessages.onResize) {
                    var detail = x.data.detail;
                    var totalHeight = window.innerHeight;
                    if (detail && detail.pageHeight) {
                        var fullPage = detail.scroll + detail.pageHeight;
                        _this.windowHeight = detail.pageHeight;
                        _this.dialogBottom = totalHeight - fullPage;
                    }
                    window['screenHeight'] = detail && detail.pageHeight ? detail.pageHeight : "";
                    window.dispatchEvent(new CustomEvent(IFramePostMessages.onResize, { detail: detail }));
                }
                else if (x && x.data && x.data.event == IFramePostMessages.onInstantGameClose) {
                    var detail = x.data.detail;
                    window.dispatchEvent(new CustomEvent(IFramePostMessages.onInstantGameClose, { detail: detail }));
                }
                else if (x && x.data && x.data.event == IFramePostMessages.authenticated) {
                    var detail = x.data.detail;
                }
            }, true);
        }
    };
    Client.prototype.detached = function () {
        _super.prototype.detached.call(this);
    };
    Client.prototype.onReconnected = function () {
    };
    Client.prototype.navigate = function (route) {
        if (this.tokenClient.isPreview)
            return; // do not allow navigation in preview mode
        this.navigationClientService.setTitle(route.title);
        this.navigationClientService.navigateAndCache(route.name);
    };
    Client.prototype.navigateToCart = function () {
        this.navigate(Enumerable.from(this.router.routes).firstOrDefault(function (x) { return x.settings.isCart; }));
    };
    Client.prototype.isActive = function (item) {
        return item === this.selectedRoute;
    };
    Client.prototype.showSearchOverlay = function () {
        this.searchOverlayShowing = !this.searchOverlayShowing;
    };
    var Client_1;
    Client.RECORDING_SESSION_ID = Guid.generateGuid();
    Client.UpdateCartCount = "UpdateCartCount";
    Client.UpdatePurchaseCount = "UpdatePurchaseCount";
    __decorate([
        computedFrom("_searchOverlayShowing"),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], Client.prototype, "searchOverlayShowing", null);
    Client = Client_1 = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Router, EntityTypeConfigurationHelper, BrandClientService, RoutingHelper,
            SignalClientService, EventAggregator, ClientLotteryClientService,
            LookupClientService,
            TokenClient,
            BindingSignaler, CacheClient, I18N,
            DialogClientService, NavigationClientService, LoginDialog, GamePlayerTicketClientService,
            NotificationClientService, ClientLotteryClientService, ExternalLogin,
            ConfigClientService])
    ], Client);
    return Client;
}(BaseApp));
export { Client };
